module.exports = __webpack_public_path__ + "img/master.302db93a.png";